import { useLocalStorage } from '@vueuse/core';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { computed, ref } from 'vue';

export interface punchInOutType {
  isUpdated: boolean;
}

export const punchOutSession = defineStore('punchOutSession', () => {

  const punch = ref<punchInOutType>(
    useLocalStorage('vueusepunchinout', {
        isUpdated: false
    }) as any,
  );

  const isPunched = computed(() => punch.value.isUpdated );

  function setPunch(val: boolean) {
    punch.value.isUpdated = val;
  }

  return {
    setPunch,
    isPunched
  } as const;
});

/**
 * Pinia supports Hot Module replacement so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(punchOutSession, import.meta.hot));
}
